import * as t from 'io-ts';

import { Decoding } from '@catawiki/runtime-toolkit';

import {
  LiveStreamCampaignStatus,
  LiveStreamCampaignStatusEnum,
} from '@/shared/constants/auctions';

const Image = t.interface({
  small: t.string,
  medium: t.string,
  original: t.string,
});

const Auctioneer = t.interface({
  id: t.number,
  name: t.string,
  image_large: Decoding.nullable(t.string),
  image_small: Decoding.nullable(t.string),
  profile_complete: t.boolean,
});

export enum AuctionStatus {
  notOpened = 'not_opened',
  opensToday = 'opens_today',
  preview = 'preview',
  openNow = 'open_now',
  closingNow = 'closing_now',
  closesToday = 'closes_today',
  closed = 'closed',
}

export const AuctionStatusEnum = t.keyof({
  [AuctionStatus.notOpened]: null,
  [AuctionStatus.opensToday]: null,
  [AuctionStatus.preview]: null,
  [AuctionStatus.openNow]: null,
  [AuctionStatus.closingNow]: null,
  [AuctionStatus.closesToday]: null,
  [AuctionStatus.closed]: null,
});

const LiveStream = t.intersection([
  t.interface({
    campaign_key: t.string,
    scheduled_start_at: t.string,
  }),
  t.partial({
    campaign_status: LiveStreamCampaignStatusEnum,
  }),
]);

export const Auction = t.intersection([
  t.interface({
    id: t.number,
    close_at: t.string,
    closed_at: Decoding.nullable(t.string),
    start_at: t.string,
    lot_count: t.number,
    number_of_lots: t.number,
    title: t.string,
    type_id: t.number,
    theme_id: Decoding.nullable(t.number),
    themed: t.boolean,
    url: t.string,
    explicit_content: t.boolean,
    images: t.interface({
      5: t.string,
      6: t.string,
      original: t.string,
    }),
    status: AuctionStatusEnum,
    promo_images: t.array(Image),
    has_context: t.boolean,
    auctioneers: t.array(Auctioneer),
  }),
  t.partial({
    live_stream: LiveStream,
  }),
]);

export type Auction = t.TypeOf<typeof Auction>;
export type Auctioneer = t.TypeOf<typeof Auctioneer>;

export const isAuctionLiveStreamEndingNow = (
  auction: Pick<Auction, 'status' | 'live_stream'>
): boolean => {
  if (!auction.live_stream?.campaign_status) return false;

  return (
    auction.live_stream.campaign_status === LiveStreamCampaignStatus.ONAIR ||
    (auction.live_stream.campaign_status === LiveStreamCampaignStatus.READY &&
      auction.status === AuctionStatus.closingNow)
  );
};

export const isAuctionLiveStreamReady = (
  auction: Pick<Auction, 'status' | 'live_stream'>
): boolean =>
  auction.live_stream?.campaign_status === LiveStreamCampaignStatus.READY &&
  !isAuctionLiveStreamEndingNow(auction);
